export const settingsPath = (basePath = "", tab) => {
  const rawBasePath = typeof basePath === "string"
    ? basePath.trim().replace(/\/+$/, "")
    : "";
  const normalizedBasePath = rawBasePath
    ? (rawBasePath.startsWith("/") ? rawBasePath : `/${rawBasePath}`)
    : "";
  const path = `${normalizedBasePath}/settings` || "/settings";
  const normalizedTab = typeof tab === "string" ? tab.trim() : "";

  return normalizedTab
    ? `${path}?tab=${encodeURIComponent(normalizedTab)}`
    : path;
};
